import { render, staticRenderFns } from "./Usermodal.vue?vue&type=template&id=ebcd0476&scoped=true"
import script from "./Usermodal.vue?vue&type=script&lang=js"
export * from "./Usermodal.vue?vue&type=script&lang=js"
import style0 from "./Usermodal.vue?vue&type=style&index=0&id=ebcd0476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcd0476",
  null
  
)

export default component.exports